import { ComponentWithPermissions } from '../../../../baseComponents/CreateRoutering/types'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import BaseScreenTableInner from '../../../../baseComponents/TwinTable/BaseScreenTableInner'
import ModalCustomerQuotesCreate from './CustomerQuotesCreateModal'
import { useState } from 'react'
import { SwitchButton, TabItems } from '../../../../baseComponents/Button/SwitchButton'
import TwinTrans from '../../../../baseComponents/TwinTrans'
import { ModalEditComponentProps } from '../../../../baseComponents/ModalsLayouts/types'
import TableCustomerQuoteOrdersConnect from './TableCustomerQuotes'
import { CustomerSellOrderComponentTy } from './types'
import TableCustomerOrdersConnect from './TableCustomerOrders'
import TableCustomerDeliveryNotesConnect from './TableCustomerDeliveryNotes'
import TableCustomerInvoicesConnect from './TableCustomerInvoices'
import './customerQuoteOrder.sass'
import ModalCreateCustomerSellDeliveryNoteConnect from './ModalCreateCustomerSellDeliveryNote'
import ModalCreateCustomerSellOrderConnect from './ModalCreateCustomerSellOrder'
import ModalCreateCustomerSellInvoiceConnect from './ModalCreateCustomerSellInvoice'
import { CustomerTypesInversedKeys } from '@teinor/erp/types/company/customer/customerTypes'
import TableCustomerTickets from './TableCustomerTickets'
import NullComponent from '../../../../baseComponents/NullComponent'
interface CustomerSellOrdersProps extends ComponentWithPermissions {
    basicData: any | null
}

const CustomerSellOrders: React.FC<CustomerSellOrdersProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()
    const { typeSell, setTypeSell } = useCustomerSellOrdersLogic()

    basicData['typeSell'] = typeSell
    basicData['setTypeSell'] = setTypeSell
    const dictCustomerSellTy: CustomerSellOrderComponentTy = {
        0: {
            TableComponent: TableCustomerQuoteOrdersConnect,
            CreateModalComponent: ModalCustomerQuotesCreate,
            extraWhereParams: { 'QuoteOrder.CustomerId': basicData?.id, is_last: true },
            newText: t('newQuote', 'Nuevo presupuesto'),
        },
        1: {
            TableComponent: TableCustomerOrdersConnect,
            CreateModalComponent: ModalCreateCustomerSellOrderConnect,
            extraWhereParams: { 'SellOrder.CustomerId': basicData?.id, is_last: true },
            newText: t('newSellOrder', 'Nuevo pedido'),
        },
        2: {
            TableComponent: TableCustomerDeliveryNotesConnect,
            CreateModalComponent: ModalCreateCustomerSellDeliveryNoteConnect,
            extraWhereParams: { 'SellDeliveryNote.CustomerId': basicData?.id, is_last: true },
            newText: t('newDeliveryNote', 'Nuevo albarán'),
        },
        3: {
            TableComponent: TableCustomerInvoicesConnect,
            CreateModalComponent: ModalCreateCustomerSellInvoiceConnect,
            extraWhereParams: { 'SellInvoice.CustomerId': basicData?.id, is_last: true },
            newText: t('newInvoice', 'Nueva factura'),
        },
        4: {
            TableComponent: TableCustomerTickets,
            CreateModalComponent: NullComponent,
            extraWhereParams: { 'SellTicket.CustomerId': basicData?.id, 'SellTicket.is_last': true },
            newText: undefined,
        },
    }
    const pageData = {
        title: '',
        newText: dictCustomerSellTy[typeSell].newText,
    }
    return (
        <BaseScreenTableInner className='single_customer_orders' TableComponent={dictCustomerSellTy[typeSell].TableComponent} pageData={pageData} userPermissions={userPermissions} extraWhereParams={dictCustomerSellTy[typeSell].extraWhereParams} CreateModalComponent={dictCustomerSellTy[typeSell].CreateModalComponent} basicData={basicData} RightHeader={ RightHeaderCustomerSellOrder} />
    )
}


const useCustomerSellOrdersLogic = () => {
    const [typeSell, setTypeSell] = useState<CustomerTypesInversedKeys | 4>(0)

    return { typeSell, setTypeSell }
}

interface RightHeaderCustomerSellOrderProps extends ModalEditComponentProps { }

export const RightHeaderCustomerSellOrder: React.FC<RightHeaderCustomerSellOrderProps> = ({ basicData }) => {
    const items: TabItems[] = [
        {
            element: <TwinTrans transKey={'quotes'}>Presupuestos</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'sellOrders'}>Pedidos</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'deliveryNotes'}>Albaranes</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'invoices'}>Facturas</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'tickets'}>Tickets</TwinTrans>
        },
    ]
    return (
        <SwitchButton className='mr-auto' onClick={(val) => basicData?.setTypeSell(val as any)} active={basicData?.typeSell} items={items} />
    )
}


export default CustomerSellOrders